import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "timeUnitPipe" })
export class TimeUnitPipe implements PipeTransform {
  public transform(time: number): string {
    return time < 60 ? "Core.Time.Second" : "Core.Time.Minute";
  }
}
